module.exports = __webpack_public_path__ + "static/fonts/AppleSDGothicNeoH.ee2dab1.ttf";